const NAME_DEFAULT_MAX_SIZE = 25;
const INSTITUTION_DEFAULT_MAX_SIZE = 10;

export const shortenName = (name: string, maxSize: number=NAME_DEFAULT_MAX_SIZE) => shortenString(name, maxSize)
export const shortenInstitution = (institution: string) => shortenString(institution, INSTITUTION_DEFAULT_MAX_SIZE);
export const shortenString = (str: string | undefined, maxSize: number) => str && str.length > maxSize ? `${str.substring(0, maxSize)}...` : str;
